import { Component, OnInit, Input, OnChanges } from "@angular/core";
import { EfficacyCriteria } from "../../store/students/state";
import { forEach, find, keyBy, filter } from "lodash";

@Component({
  selector: "group-criteria-panel-display",
  templateUrl: "./group-criteria-panel-display.component.html",
  styleUrls: ["./group-criteria-panel-display.component.scss"],
})
export class GroupCriteriaPanelDisplayComponent implements OnInit, OnChanges {
  @Input() groupCriteria: Array<EfficacyCriteria>;
  @Input() columns;

  groupCriteriaColumnNames: { [id: number]: { name: string } };

  constructor() {}

  ngOnInit() {}

  ngOnChanges(change) {
    if (change && change.columns) {
      // create a dictionary of [columnId: column] for easy lookup
      this.columns = keyBy(this.columns, "id");
      this.groupCriteria = filter(this.groupCriteria, (criteria) => {
        return find(this.columns, ["id", criteria.student_kpi_id]) != null;
      });
    }
  }
}
